export default __webpack_public_path__ + "static/media/me.b210283b.png";